/*
 * Jira Ticket:
 * Created Date: Wed, 1st Apr 2020, 15:02:53 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import gql from 'graphql-tag';
import { getListRoles } from 'DataProvider/queries';

export const getListOrganisationQuery = gql`
  query allOrganisations(
    $page: Int
    $perPage: Int
    $sortField: String
    $sortOrder: String
    $filter: OrganisationFilter
  ) {
    items: allOrganisations(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
      filter: $filter
    ) {
      id
      name
      statistics {
        numberOfProjects
        numberOfSites
        numberOfUsers
      }
      contact {
        name
        phone
        email
        position
      }
      subscription {
        subscriptionTier {
          id
          capabilities {
            id
            enabled
            __typename
          }
        }
      }
      checklistRequired
      projectAccess
      role
      addressLine1
      addressLine2
      city
      postCode
      country
    }
    total: _allOrganisationsMeta(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
      filter: $filter
    ) {
      count
      __typename
    }
  }
`;

export default async ({ client, params }) => {
  try {
    // account for pagination not being reduced on custom lists
    const result = await client.query({
      query: getListOrganisationQuery,
      variables: {
        filter: params.filter,
        sortField: params.sort && params.sort.field,
        sortOrder: params.sort && params.sort.order,
        page:
          params.pagination && params.pagination.page > 0
            ? params.pagination.page - 1
            : params.pagination.page,
        perPage: params.pagination.perPage,
      },
      fetchPolicy: 'network-only',
    });
    if (!params.filter) {
      await getListRoles({ client, params }); //only update roles if the user isn't filtering
    }
    return result;
  } catch (e) {
    if (e.graphQLErrors && e.graphQLErrors.length) {
      const [error] = e.graphQLErrors;
      const message = error.message;
      throw new Error(message);
    }
    throw e;
  }
};
